var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  label: "descripcion",
                  id: "ruta",
                  options: _vm.rutas,
                  placeholder: "Escriba una ruta..."
                },
                on: { input: _vm.inputRuta, search: _vm.onSearchRutas },
                model: {
                  value: _vm.selectedRuta,
                  callback: function($$v) {
                    _vm.selectedRuta = $$v
                  },
                  expression: "selectedRuta"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "ruta" } }, [_vm._v("Ruta")])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    id: "numero_cartilla",
                    placeholder: "Escriba un número..."
                  },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.cargarCartillas.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.numero_cartilla,
                    callback: function($$v) {
                      _vm.numero_cartilla = $$v
                    },
                    expression: "numero_cartilla"
                  }
                },
                [_vm._v("\n            Número de cartilla\n          ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-info",
              attrs: { type: "button" },
              on: { click: _vm.cargarCartillas }
            },
            [_c("i", { staticClass: "fa fa-search" })]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "table-responsive",
        staticStyle: { "max-height": "300px" }
      },
      [
        _c("table", [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.cartillas, function(cartilla, index) {
                return _c("tr", { key: index }, [
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(cartilla.ruta.descripcion) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " + _vm._s(cartilla.fecha) + "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(cartilla.descripcion_dia_cobro) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(cartilla.numero_documento) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(cartilla.recaudador.nombre) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(cartilla.nombre_cliente) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(cartilla.observacion) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(cartilla.numero_pagos) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.moneyFormat(cartilla.valor_pagos)) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.moneyFormat(cartilla.venta_total)) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.moneyFormat(cartilla.saldo)) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", [
                      _c("label", { attrs: { for: "seleccionar" + index } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cartillasSeleccionadas,
                              expression: "cartillasSeleccionadas"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            id: "seleccionar" + index
                          },
                          domProps: {
                            value: cartilla.id,
                            checked: Array.isArray(_vm.cartillasSeleccionadas)
                              ? _vm._i(
                                  _vm.cartillasSeleccionadas,
                                  cartilla.id
                                ) > -1
                              : _vm.cartillasSeleccionadas
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.cartillasSeleccionadas,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = cartilla.id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.cartillasSeleccionadas = $$a.concat([
                                      $$v
                                    ]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.cartillasSeleccionadas = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.cartillasSeleccionadas = $$c
                              }
                            }
                          }
                        }),
                        _c("span")
                      ])
                    ])
                  ])
                ])
              }),
              _vm._v(" "),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cartillas.length === 0,
                      expression: "cartillas.length === 0"
                    }
                  ]
                },
                [
                  _c("td", { attrs: { colspan: "11" } }, [
                    _vm._v("No se ha encontrado recaudaciones")
                  ])
                ]
              )
            ],
            2
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.asignar }
        },
        [
          _c("i", { staticClass: "fa fa-check" }),
          _c("span", [_vm._v("Asignar seleccionadas")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-danger btn--text", on: { click: _vm.cerrar } },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cerrar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Cartillas adicionales")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Ruta")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de venta")]),
        _vm._v(" "),
        _c("th", [_vm._v("Día de recaudación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Número de documento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Recaudador")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Observación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Número de pagos")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor de pago")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b835fe2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b835fe2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/CartillasAdicionales.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0b835fe2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/CartillasAdicionales.vue
// module chunks = 0